/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto
 */
export interface GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto
     */
    assetTypeSubsystemComponentClassId: string;
    /**
     * Code of the subsystem
     * @type {string}
     * @memberof GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto
     */
    subsystemCode: string;
    /**
     * Code of the asset type
     * @type {string}
     * @memberof GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto
     */
    assetTypeCode: string;
    /**
     * Code of the component class
     * @type {string}
     * @memberof GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto
     */
    componentClassCode: string;
    /**
     * Count of associated componentTypes
     * @type {number}
     * @memberof GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto
     */
    associatedComponentTypesCount: number;
    /**
     * 
     * @type {Date}
     * @memberof GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto interface.
 */
export function instanceOfGetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto(value: object): value is GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('assetTypeSubsystemComponentClassId' in value) || value['assetTypeSubsystemComponentClassId'] === undefined) return false;
    if (!('subsystemCode' in value) || value['subsystemCode'] === undefined) return false;
    if (!('assetTypeCode' in value) || value['assetTypeCode'] === undefined) return false;
    if (!('componentClassCode' in value) || value['componentClassCode'] === undefined) return false;
    if (!('associatedComponentTypesCount' in value) || value['associatedComponentTypesCount'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDtoFromJSON(json: any): GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto {
    return GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDtoFromJSONTyped(json, false);
}

export function GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assetTypeSubsystemComponentClassId': json['assetTypeSubsystemComponentClassId'],
        'subsystemCode': json['subsystemCode'],
        'assetTypeCode': json['assetTypeCode'],
        'componentClassCode': json['componentClassCode'],
        'associatedComponentTypesCount': json['associatedComponentTypesCount'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
    };
}

export function GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDtoToJSON(json: any): GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto {
    return GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDtoToJSONTyped(json, false);
}

export function GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDtoToJSONTyped(value?: GetAllAssetTypeSubsystemComponentClassComponentTypesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assetTypeSubsystemComponentClassId': value['assetTypeSubsystemComponentClassId'],
        'subsystemCode': value['subsystemCode'],
        'assetTypeCode': value['assetTypeCode'],
        'componentClassCode': value['componentClassCode'],
        'associatedComponentTypesCount': value['associatedComponentTypesCount'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
    };
}

